import React from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { Card, CardContent, Button, Grid, FormControl, TextField, InputAdornment, IconButton } from '@mui/material';

import { useFetchInitUsers } from './hooks'
import { Eye, EyeOff } from 'react-feather';

export const PasswordChange = (props) => {
    
    const location = useLocation();
    const paramsURL = useParams();
    const useFetchInit = useFetchInitUsers({location, paramsURL})

    const {
        user,
        globalStates,
        Forms,
        Actions
    } = useFetchInit
    
    const {
        showPassword,
        setShowPassword,
        showConfirmPassword,
        setShowConfirmPassword,
        loadingSubmitForm
    } = globalStates
    
    const { onSubmitForm } = Actions

    const { FormUser } = Forms
    const { formState, onInputChange } = FormUser

    return (
        <Card style={{zIndex:'1'}}>
            <CardContent>
                <div className='h4 mt-1 mb-1'>
                    Cambio de Contraseña
                </div>
                <div className="border-bottom border-dark"></div>
                {/* {loadingFetchSpecificUser && ( <LinearLoading /> )} */}

                <div className="pt-3"></div>
                <p className='text-danger'>* campos obligatorios</p>
                <div className="pt-2"></div>

                <form onSubmit={onSubmitForm}>
                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <FormControl fullWidth>
                                <TextField
                                    id="nombreusuario"
                                    name="nombreusuario"
                                    value={user.username}
                                    onChange={onInputChange}
                                    label='Nombre de usuario'
                                    size='small'
                                    type="text"
                                    variant="standard"
                                    // hiddenLabel
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    required
                                />
                            </FormControl>
                        </Grid>
                    </Grid>

                    <div className="pt-4"></div>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <FormControl fullWidth>
                                <TextField
                                    id="userPassword"
                                    name="userPassword"
                                    value={formState.userPassword}
                                    onChange={onInputChange}
                                    label='Contraseña'
                                    size='small'
                                    type={showPassword ? 'text' : 'password'}
                                    variant="standard"
                                    InputProps={{
                                        readOnly: false,
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => setShowPassword(!showPassword)}
                                                    edge="end"
                                                >
                                                    {showPassword
                                                        ? <EyeOff />
                                                        : <Eye />
                                                    }
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                    required={false}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                    <div className="pt-4"></div>
                        <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                        <Grid item xs={12} sm={12} md={6} lg={6}>
                            <FormControl fullWidth>
                                <TextField
                                    id="userConfirmPassword"
                                    name="userConfirmPassword"
                                    value={formState.userConfirmPassword}
                                    onChange={onInputChange}
                                    label='Confirme su contraseña'
                                    size='small'
                                    type={showConfirmPassword ? 'text' : 'password'}
                                    variant="standard"
                                    InputProps={{
                                        readOnly: false,
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton
                                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                                    edge="end"
                                                >
                                                    {showConfirmPassword
                                                        ? <EyeOff />
                                                        : <Eye />
                                                    }
                                                </IconButton>
                                            </InputAdornment>
                                        )
                                    }}
                                    required={false}
                                />
                            </FormControl>
                        </Grid>
                    </Grid>
                    <div className="pt-4"></div>
                    <Grid container>
                        <Grid item>
                            <div className='update ml-auto mr-auto'>
                                <Button
                                    style={{background: "#4b4b4c"}}
                                    variant="contained"
                                    type='submit'
                                    disabled={loadingSubmitForm}
                                >
                                    <i className="fa-regular fa-floppy-disk"></i> &nbsp; Guardar
                                </Button>
                            </div>
                        </Grid>
                    </Grid>
                </form>
            </CardContent>
        </Card>
    )

}
